import * as React from 'react';
import PropTypes from 'prop-types';
import { Card, StampCard, Button, Icon } from 'tabler-react';
import modal from '../../components/Modal';
import Withdrowal from './Withdrowal';
import Table from './Table';
import i18n from '../../shared/i18n';

class AffiliateOverview extends React.Component {
  withdraw = () => {
    const { affWithdrawAccount, refreshAmount } = this.props;
    modal(
      <Withdrowal
        affWithdrawAccount={affWithdrawAccount}
        refreshAmount={refreshAmount}
      />,
      {
        title: i18n.t('dash-aff-withdrawtitle'),
      },
    );
  };

  Records = initialTab => {
    modal(
      <Table
        withdrawList={this.props.withdrawList}
        bonuses={this.props.bonuses}
        initialTab={initialTab}
      />,
    );
  };

  render() {
    const { balance, recent } = this.props;

    return (
      <Card>
        <Card.Header className="overview">
          <Card.Title> {i18n.t('dash-aff-overview')} </Card.Title>
          <div className="tab1 tab" onClick={() => this.Records(i18n.t('dash-aff-withdrawhistory'))}>
            <Icon name="file-minus" /> {i18n.t('dash-aff-withdrawhistory')}
          </div>
          <div className="tab2 tab" onClick={() => this.Records(i18n.t('dash-aff-refershistory'))}>
            <Icon name="file-plus" /> {i18n.t('dash-aff-refershistory')}
          </div>
        </Card.Header>
        <Card.Body className="affiliate-overview">
          <StampCard
            color="red"
            icon="credit-card"
            header={recent || '0.00'}
            footer={i18n.t('dash-aff-pending')}
          />
          <StampCard
            color="success"
            icon="credit-card"
            header={balance || '0.00'}
            footer={i18n.t('dash-aff-balance')}
          />
          <Button
            className="affiliate-show-withdrowal-btn"
            outline
            color="primary"
            onClick={this.withdraw}>
            {i18n.t('dash-aff-withdrawsetting')}
          </Button>
        </Card.Body>
      </Card>
    );
  }
}

AffiliateOverview.propTypes = {
  balance: PropTypes.number,
  recent: PropTypes.number,
  refreshAmount: PropTypes.func,
  bonuses: PropTypes.array,
  withdrawList: PropTypes.array,
  affWithdrawAccount: PropTypes.object,
};

export default AffiliateOverview;
